<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'app',
  created() {
    // let json=require('/api/city')
    axios.get('/city.json').then(res=>{
      let data=res.data
      this.$store.dispatch('getAddress',data)
    })

  },

}
</script>
<style>
.bigData{
  padding: 0!important;
  margin: 0!important;
}
img{
  border: none!important;
}
</style>
<style lang='scss'>
  .pd-20{
    padding: 20px;
  }
  .justify-space-between{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .el-date-editor .el-range-separator{
    width: auto!important;
  }
  .el-button--primary{
    background-color: #1c3faa!important;
  }
  .el-pagination{
    font-size: 14px;
  }

  .el-pagination button,
  .el-pager li{
    background: none!important;
    color: rgba(45,55,72,var(--text-opacity));
  }
  .el-pager li.active{
    background: #fff!important;
    border-radius: .375rem;
    font-weight: 500;
    color: rgba(45,55,72,var(--text-opacity))!important;
  }
</style>
